import script from "./SponsorsAndPartners.vue?vue&type=script&setup=true&lang=ts"
export * from "./SponsorsAndPartners.vue?vue&type=script&setup=true&lang=ts"

import "./SponsorsAndPartners.vue?vue&type=style&index=0&id=913135e8&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-913135e8"]])

export default __exports__